import { NgModule } from "@angular/core";
import { MatGoogleMapsAutocompleteModule } from "@angular-material-extensions/google-maps-autocomplete";
import { FuseSharedModule } from "@fuse/shared.module";
import { AddressComponent } from "@app/wapps/core/address/address.component";
import { FuseDirectivesModule } from "@fuse/directives/directives";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomMaterialModule } from "@app/wapps/core/material.module";
import { AddressFormComponent } from "@app/wapps/core/address/address-form.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { GoogleMapsLoaderService } from "../maps-api-loader.service";
import { GeocodeService } from "./geocode.service";
import { GoogleMapsModule } from "@angular/google-maps";
import { IMaskModule } from "angular-imask";

@NgModule({
    declarations: [AddressComponent, AddressFormComponent],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CustomMaterialModule,
        GoogleMapsModule,
        FuseSharedModule,
        MatGoogleMapsAutocompleteModule,
        FuseDirectivesModule,
        FlexLayoutModule,
        IMaskModule,
    ],
    exports: [AddressComponent, AddressFormComponent, CustomMaterialModule],
    providers: [GeocodeService, GoogleMapsLoaderService],
})
export class AddressModule {}
